import React from 'react'
import { LazyImageComponent } from '../../widgets/tiles/LazyImageComponent';
import { Checkbox } from "@material-ui/core";
import { BsCheckCircleFill, BsCircle } from 'react-icons/bs';
import Availability from '../../popup/Availability';
import { CopyUrlAlert } from '../../widgets/tiles/CopyURLAlert';
import AdvancedTagSearch from '../../popup/AdvancedTagSearch';
import { ImagePopup } from '../../widgets/tiles/ImagePopUp';
import { VideoPopup } from '../../widgets/tiles/VideoPopUp';
import { OverlayTrigger,Tooltip } from 'react-bootstrap';
import { FaAward } from 'react-icons/fa';
import { toAbsoluteUrl } from '../../../_helpers';
import SVG from "react-inlinesvg";

export default function SearchGridComponent({stoneData,isItemSelected,labelId,handleClick,setDetailView,setDiamondSelected}) {
    

    function numberWithCommas(x) {
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const GenerateTitle = (row) => {
        let title = ""
        // if(row.Lab){
        //     title += row.Lab
        // }
        if(row.shape){
            title += " "
            title += row.shape
        }
        if(row.carat){
            title += " "
            title += row.carat.toFixed(2) 
        }
        // if(row.f_intensity){
        //     title += " "
        //     title += row.f_intensity
        // }
        if(row.color){
            title += " "
            title += row.color
        }
        if(row.clarity){
            title += " "
            title += row.clarity
        }

        if(row.cut){
            title += " "
            title += row.cut
        }
       
        if(row.polish){
            title += " "
            title += row.polish
        }

        if(row.symmetry){
            title += " "
            title += row.symmetry
        }

        if(row.fluorescence){
            title += " "
            title += row.fluorescence
        }
        // console.log(title.length)
        return title.length > 36 ? `${title.substring(0, 38)}...`: title
        // return title
    }

  return (
    <>
        <div
            className={`mb-5 px-2 grid_box ${stoneData?.diamondType === "N" ? "natTab" : "labTab"}`}
            key={stoneData?.stockID}
            id={stoneData?.stockID}
        >
             <div className="row m-0 card gridData ribbon ribbon-top ribbon-left">
                {stoneData?.diamondType === "N" || stoneData?.diamondType === "W" ? null: <div className="ribbon-target custom-top-ribbon lab-ribbon" style={{top:"-2px",right:"20px"}} >Lab</div> }
                { (stoneData?.diamondType === "L" ) && (stoneData?.growthType && stoneData?.growthType === "HPHT")  ? 
                <div class="ribbon-target bg-light-success-solid-40 custom-left-ribbon" style={{top :"180px",left:"-3px"}}>
                    HPHT
                </div> : null }
                { (stoneData?.diamondType === "L" ) && (stoneData?.growthType && stoneData?.growthType === "CVD")  ? 
                <div class="ribbon-target bg-light-success-solid-40 custom-left-ribbon" style={{top :"180px",left:"-3px"}}>
                    CVD
                </div> : null }
                <div className="col-12 p-0 d-flex align-items-center justify-content-center bg-gray-200 position-relative" style={{height:"220px"}}>
                    <div className="gridCheck">
                        <Checkbox
                            checked={isItemSelected}
                            className=""
                            inputProps={{ 'aria-labelledby': labelId }}
                            onClick={(event) => handleClick(event, stoneData?.stockID)}
                            icon={<BsCircle />} checkedIcon={<BsCheckCircleFill />}
                        />
                    </div>
                    <LazyImageComponent data={stoneData} setDetailView={setDetailView} setDiamondSelected={setDiamondSelected} />
                </div>
                <div className="col-12 mt-3 mb-1 d-flex justify-content-between align-items-center">
                    <div className="d-flex text-nowrap">
                        <Availability availability={stoneData?.availability}/>
                        {stoneData?.loatNo}
                        <span className='ml-1'><CopyUrlAlert text={stoneData?.loatNo}/></span>

                    </div>
                    <div className='d-flex'>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            className="mx-2 text-nowrap text-left"
                            href={stoneData?.certificate_link}
                        >
                            {stoneData?.lab}: {stoneData?.certificate}
                        </a>
                        <CopyUrlAlert text={stoneData?.certificate}/>
                    </div>
                </div>
                <hr className="w-100 my-2" />
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <AdvancedTagSearch {...stoneData}/>
                    <div className="d-flex justify-content-start align-items-center">
                            {stoneData?.image ? 
                                <ImagePopup
                                    Image={stoneData?.image}
                                    Shape={stoneData?.shape}
                                />
                            : null }
                            {stoneData?.video ? 
                                <VideoPopup
                                    ProductId={stoneData?.id}
                                    WLDiamondType={stoneData?.diamondType}
                                    Certi_No={stoneData?.certificate}
                                    video={stoneData?.video}
                                />
                            :null}
                            {stoneData?.certificate  && (
                                <span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip">Certificate</Tooltip>
                                        }
                                    >
                                        <a
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-primary mx-1 text-left"
                                            href={
                                                stoneData?.certificate_link
                                            }
                                        >
                                            <FaAward />
                                        </a>
                                    </OverlayTrigger>
                                </span>
                            )}
                        </div>
                </div>
                <hr className="w-100 my-2" />
                <div className="col-12 d-flex px-2 align-items-center">
                    <div className="text-center">
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    {stoneData?.shape}
                                </Tooltip>
                            }
                        >
                            <SVG width="40px" height="25px" src={toAbsoluteUrl(`/media/shape/svg_shape/${stoneData?.shape.toLowerCase()}.svg`)} />
                        </OverlayTrigger>
                    </div>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip">
                                <>
                                    {stoneData?.carat?.toFixed(2)} {stoneData?.shape}{" "}
                                    {stoneData?.color}{" "}
                                    {stoneData?.clarity} {stoneData?.cut}{" "}
                                    {stoneData?.polish} {stoneData?.symmetry} {stoneData?.fluorescence}
                                </>
                            </Tooltip>
                        }
                    >
                        <span className="grid_title"> {GenerateTitle(stoneData)} </span> 
                    </OverlayTrigger>
                </div>
                <hr className="w-100 my-1" />
                <div className="col-12 d-flex justify-content-between align-items-end">
                    <div className="d-flex flex-column">
                        <div className="small" >
                            {stoneData?.supplierDiscount ? <span className={`${(stoneData?.supplierDiscount >= 0) ? 'text-success' : 'text-danger'}`}>{stoneData?.supplierDiscount}%</span> : null}
                        </div>
                        <span className="text-muted small">$/CT: <span className="text-dark font-size-xl">${numberWithCommas(stoneData?.supplierRate)}</span ></span>
                    </div>
                    <div className="grid-total-title">
                        <span className="text-dark small">USD</span>
                        <span className="font-size-h3">${numberWithCommas(stoneData?.supplierPrice)}</span >
                    </div>
                </div>
                <hr className="w-100 my-2" />
                <div className="col-12 mb-2 d-flex justify-content-between px-2 mtdr">
                    <span className="text-muted font-size-sm">M: <span className="text-dark font-size-sm">{numberWithCommas(parseFloat(stoneData?.length))}*{numberWithCommas(parseFloat(stoneData?.width))}*{numberWithCommas(parseFloat(stoneData?.height))}</span ></span>
                    <span className="text-muted font-size-sm">T: <span className="text-dark font-size-sm">{numberWithCommas(parseFloat(stoneData?.tablePercent))}%</span ></span>
                    <span className="text-muted font-size-sm">D: <span className="text-dark font-size-sm">{numberWithCommas(parseFloat(stoneData?.depthPercent))}%</span ></span>
                    {(stoneData?.ratio && stoneData?.shape?.toLowerCase() !== 'round')  ? <span className="text-muted font-size-sm">R: <span className="text-dark font-size-sm">{stoneData?.ratio ? numberWithCommas(parseFloat(stoneData?.ratio)):"-"}</span ></span> : ""}
                </div>
            </div>
        </div>
    </>
  )
}
